export function GetCardType(number) {
  // Visa
  var re = new RegExp('^4')
  if (number.match(re) != null) return 'Visa'

  // MasterCard
  // Updated for MasterCard 2017 BINs expansion
  if (
    /^(5[1-5][0-9]{14}|2(22[1-9][0-9]{12}|2[3-9][0-9]{13}|[3-6][0-9]{14}|7[0-1][0-9]{13}|720[0-9]{12}))$/.test(
      number
    )
  )
    return 'MasterCard'

  // AMEX
  re = new RegExp('^3[47]')
  if (number.match(re) != null) return 'AMEX'

  return ''
}

export * from './general'
